import React from 'react';
import '../less';
import {
    MAIN,
    CARDS,
    PROJECT_SUPPORT
} from '../../../../auxiliary-components/Breadcrumbs/collection/breadcrumbs.config';
import TextAboveFooter from "../../../../auxiliary-components/shared/TextAboveFooter/views/TextAboveFooter.c";
import Slider from "react-slick";
import banner_img from '../img/image-pro-support.png';
import info_card_img from '../img/info-card-img.png';
import share_icon from '../img/share_icon.svg';
import { table } from '../utils/table';
import textAboveFooterData from '../textAboveFooterData.json';
import Order from "../../views/orderAction";
import Banner from "../../../../auxiliary-components/shared/Banner";
import FilesForDownload from '../../../../auxiliary-components/shared/FilesForDownload/views/file.c';
import scrollToOrder from 'utils/scrollToOrder';
import DownloadApp from "../../views/downloadApp.c";
import QuestionsAdminBlock from "../../../../auxiliary-components/shared/QuestionsAdmin";
import { Preloader } from "MWComponents";
import SliderComponent from "../../../../auxiliary-components/shared/Slider";

export default function template() {
    const links = [MAIN, CARDS, PROJECT_SUPPORT],
      isMobile = this.isViewportMobile(),
      isUtm = this.props.location.search.indexOf('utm_') !== -1,
      tariffsTable = isMobile ? (
        <div className={`${this.state.modes[1]}-table-column`}>
          <div className={`${this.state.modes[1]}-table-column-item`}>
            <div className={`${this.state.modes[1]}-table-column-item-text`} dangerouslySetInnerHTML={{__html: this.l10n('PROJECT_SUPPORT_INFO_TARIFFS_TABLE_COLUMN_1_TEXT_1_MOB')}}></div>
          </div>
          <div className={`${this.state.modes[1]}-table-column-item`}>
            <div className={`${this.state.modes[1]}-table-column-item-title`} dangerouslySetInnerHTML={{__html: this.l10n('PROJECT_SUPPORT_INFO_TARIFFS_TABLE_COLUMN_1_TEXT_2')}}></div>
            <div className={`${this.state.modes[1]}-table-column-item-text`} dangerouslySetInnerHTML={{__html: this.l10n('PROJECT_SUPPORT_INFO_TARIFFS_TABLE_COLUMN_2_TEXT_2')}}></div>
          </div>
          <div className={`${this.state.modes[1]}-table-column-item`}>
            <div className={`${this.state.modes[1]}-table-column-item-title`} dangerouslySetInnerHTML={{__html: this.l10n('PROJECT_SUPPORT_INFO_TARIFFS_TABLE_COLUMN_1_TEXT_3')}}></div>
            <div className={`${this.state.modes[1]}-table-column-item-text green`} dangerouslySetInnerHTML={{__html: this.l10n('PROJECT_SUPPORT_INFO_TARIFFS_TABLE_COLUMN_2_TEXT_3')}}></div>
          </div>
          <div className={`${this.state.modes[1]}-table-column-item`}>
            <div className={`${this.state.modes[1]}-table-column-item-title`} dangerouslySetInnerHTML={{__html: this.l10n('PROJECT_SUPPORT_INFO_TARIFFS_TABLE_COLUMN_1_TEXT_4')}}></div>
            <div className={`${this.state.modes[1]}-table-column-item-text green`} dangerouslySetInnerHTML={{__html: this.l10n('PROJECT_SUPPORT_INFO_TARIFFS_TABLE_COLUMN_2_TEXT_4')}}></div>
          </div>
          <div className={`${this.state.modes[1]}-table-column-item`}>
            <div className={`${this.state.modes[1]}-table-column-item-title`} dangerouslySetInnerHTML={{__html: this.l10n('PROJECT_SUPPORT_INFO_TARIFFS_TABLE_COLUMN_1_TEXT_5')}}></div>
            <div className={`${this.state.modes[1]}-table-column-item-text`} dangerouslySetInnerHTML={{__html: this.l10n('PROJECT_SUPPORT_INFO_TARIFFS_TABLE_COLUMN_2_TEXT_5')}}></div>
          </div>
        </div>

      ) : (table.map((item, i) => {
        return (
          <div key={i} className={`${this.state.modes[1]}-table-column ${i === 0 ? '': 'values'}`}>
              <div className={`${this.state.modes[1]}-table-column-item`} dangerouslySetInnerHTML={{__html: this.l10n(item.type)}}></div>
              <div className={`${this.state.modes[1]}-table-column-item`} dangerouslySetInnerHTML={{__html: this.l10n(item.currency)}}></div>
              <div className={`${this.state.modes[1]}-table-column-item ${i === 0 ? '' : 'green'}`} dangerouslySetInnerHTML={{__html: this.l10n(item.service)}}></div>
              <div className={`${this.state.modes[1]}-table-column-item ${i === 0 ? '' : 'green'}`} dangerouslySetInnerHTML={{__html: this.l10n(item.enrollment)}}></div>
              <div className={`${this.state.modes[1]}-table-column-item`} dangerouslySetInnerHTML={{__html: this.l10n(item.withdrawal)}}></div>
          </div>
        )
    })),
      tariffs = 'https://conditions-and-rules.a-bank.com.ua/media/uploads/Tarif/Zhovta_ua.pdf',
      tariffsBlock = (
        <div className={`${this.state.mode === this.state.modes[1] ? "active" : ""} ${this.state.modes[1]}`}>
          <div className={`${this.state.modes[1]}-table`}>
            {tariffsTable}
          </div>
          <div className={`${this.state.modes[1]}-desc`}>
            {this.l10n('PROJECT_SUPPORT_INFO_TARIFFS_DESC_TEXT_1')}
            <a className="link" href={tariffs} target="_blank">
              {this.l10n('PROJECT_SUPPORT_INFO_TARIFFS_DESC_TEXT_2')}
              <img alt="href_img" src={share_icon}></img>
            </a>
          </div>
        </div>
      ),
      settings = {
          centerMode: true,
          infinite: false,
          slidesToShow: 1,
          speed: 500,
          dots: false,
          variableWidth: true,
          arrows: false,
      },
      nav = isMobile ?
      (<div className='nav-bar'>
        <Slider {...settings}>
            <button className={`${this.state.mode === this.state.modes[0] ? "selected" : ""} nav-bar-item`}
                    onClick={this.toggleMode}
                    name={this.state.modes[0]}>
                {this.l10n('PROJECT_SUPPORT_NAV_BTN_1')}
            </button>
            <button className={`${this.state.mode === this.state.modes[1] ? "selected" : ""} nav-bar-item`}
                    onClick={this.toggleMode}
                    name={this.state.modes[1]}>
                {this.l10n('PROJECT_SUPPORT_NAV_BTN_2')}
            </button>
            <button className={`${this.state.mode === this.state.modes[2] ? "selected" : ""} nav-bar-item`}
                    onClick={this.toggleMode}
                    name={this.state.modes[2]}>
                {this.l10n('PROJECT_SUPPORT_NAV_BTN_3')}
            </button>
          </Slider>
        </div>
      )
      : (
          <div className='nav-bar'>
              <button className={`${this.state.mode === this.state.modes[0] ? "selected" : ""} nav-bar-item`}
                      onClick={this.toggleMode}
                      name={this.state.modes[0]}>
                  {this.l10n('PROJECT_SUPPORT_NAV_BTN_1')}
              </button>
              <button className={`${this.state.mode === this.state.modes[1] ? "selected" : ""} nav-bar-item`}
                      onClick={this.toggleMode}
                      name={this.state.modes[1]}>
                  {this.l10n('PROJECT_SUPPORT_NAV_BTN_2')}
              </button>
              <button className={`${this.state.mode === this.state.modes[2] ? "selected" : ""} nav-bar-item`}
                      onClick={this.toggleMode}
                      name={this.state.modes[2]}>
                  {this.l10n('PROJECT_SUPPORT_NAV_BTN_3')}
              </button>
          </div>
      ),
      orderCards = (
        <div className="card-order-wrapper" id='order'>
          <div className="left-side">
            <div className="title">{this.l10n('GC_WANT_TO_ORDER')}</div>
            <div className="sub-title">{this.l10n('GC_WANT_TO_ORDER_SUBTITLE')}</div>
            <div className="card-order">
              <div className="order-wrapper green-card">
                <Order
                  {...this.props}
                  row={!isMobile}
                  utmParams={this.utmParams}
                  type="atb"
                />
              </div>
            </div>
          </div>
        </div>
      ),
      app = isMobile && isUtm ?
        (
          <div className="content">
            {orderCards}
          </div>
        )
        :
        (<div className="download-app-wrapper" id='order'>
          <DownloadApp {...this.props} />
        </div>);

    return (
        <div className='module-project-support'>
          <div className='slider-container'>
            {this.state.loader ? <Preloader></Preloader> : <SliderComponent isMobile={isMobile} widget={this.widgetsHelper.getWidget.call(this, 'main_banner')}></SliderComponent>}
          </div>
            {isMobile ? nav : ''}
            <div className='content'>
                {isMobile ? '' : nav}
                <div className={`${this.state.mode === this.state.modes[0] ? "active" : ""} ${this.state.modes[0]}`}>
                    <div className={`${this.state.modes[0]}-description`}>
                        <img alt="card_img" src={info_card_img} ></img>
                        <div className={`${this.state.modes[0]}-description-text`}>
                            <div className={`${this.state.modes[0]}-description-text-title title`}>{this.l10n('PROJECT_SUPPORT_INFO_DES_TEXT_TITLE')}</div>
                            <div className={`${this.state.modes[0]}-description-text-desc`}>{this.l10n('PROJECT_SUPPORT_INFO_DES_TEXT')}</div>
                        </div>
                    </div>
                    <div className={`${this.state.modes[0]}-usage`}>
                        <div className={`${this.state.modes[0]}-usage-title title`}
                             dangerouslySetInnerHTML={{__html: isMobile ? this.l10n('PROJECT_SUPPORT_INFO_USAGE_TITLE_MOB') : this.l10n('PROJECT_SUPPORT_INFO_USAGE_TITLE')}}>
                        </div>
                        <div className={`${this.state.modes[0]}-usage-cards`}>
                            <div className={`${this.state.modes[0]}-usage-cards-item`}
                                 dangerouslySetInnerHTML={{__html: this.l10n('PROJECT_SUPPORT_INFO_USAGE_CARDS_TEXT_1')}}></div>
                            <div className={`${this.state.modes[0]}-usage-cards-item`}
                                 dangerouslySetInnerHTML={{__html: this.l10n('PROJECT_SUPPORT_INFO_USAGE_CARDS_TEXT_2')}}></div>
                            <div className={`${this.state.modes[0]}-usage-cards-item`}
                                 dangerouslySetInnerHTML={{__html: this.l10n('PROJECT_SUPPORT_INFO_USAGE_CARDS_TEXT_3')}}></div>
                            <div className={`${this.state.modes[0]}-usage-cards-item bottom`}
                                 dangerouslySetInnerHTML={{__html: this.l10n('PROJECT_SUPPORT_INFO_USAGE_CARDS_TEXT_4')}}></div>
                            <div className={`${this.state.modes[0]}-usage-cards-item bottom`}
                                 dangerouslySetInnerHTML={{__html: this.l10n('PROJECT_SUPPORT_INFO_USAGE_CARDS_TEXT_5')}}></div>
                            <div className={`${this.state.modes[0]}-usage-cards-item bottom`}
                                 dangerouslySetInnerHTML={{__html: this.l10n('PROJECT_SUPPORT_INFO_USAGE_CARDS_TEXT_6')}}></div>
                        </div>
                    </div>
                </div>
            </div>
          {isMobile ? tariffsBlock : ''}
            <div className='content'>
              {isMobile ? '' : tariffsBlock}
                <div className={`${this.state.mode === this.state.modes[2] ? "active" : ""} ${this.state.modes[2]}`}>
                  <div className="content">
                    <QuestionsAdminBlock page={'green-card'} isMobile={isMobile} widget={this.widgetsHelper.getWidget.call(this, 'questions')}></QuestionsAdminBlock>
                  </div>
                </div>
            </div>
              {app}

            <FilesForDownload page={'white-page'} lang={this.props.lang} widget={this.widgetsHelper.getWidget.call(this, 'files_to_download')}/>

            <div className="disclaimer-wrapper">
              <TextAboveFooter widget={this.widgetsHelper.getWidget.call(this, 'text_above_footer')} isMobile={isMobile}></TextAboveFooter>
            </div>
        </div>
    );
}
